import { Component, OnInit } from "@angular/core";
import { PrintService } from "../print.service";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-print-billing-report",
    templateUrl: "./print-billing-report.component.html",
    styleUrls: ["./print-billing-report.component.scss"],
    standalone: false
})
export class PrintBillingReportComponent implements OnInit {
  now: Date;
  docType = "All";
  fromDate;
  toDate;
  docUID;
  code;

  constructor(public print: PrintService, private route: ActivatedRoute, public translate: TranslateService) {
    this.now = new Date();
  }

  ngOnInit(): void {
    this.docType = this.route.snapshot.params.docType;
    this.fromDate = this.route.snapshot.params.fromDate;
    this.toDate = this.route.snapshot.params.toDate;
    this.docUID = this.route.snapshot.params.docUID;
    this.code = this.route.snapshot.params.code;
    this.print.loadBillingReport(this.docType, this.fromDate, this.toDate, this.docUID, this.code);
  }
}
